export const TOKEN_KEY = "token";
export const SESSION_TYPE_KEY = "sessionType";
